/* ClickaByte Theme Injector (cb-theme.js)
   - Injects header/footer partials
   - Sets up theme switching, background, progress bar, particles
   - Mobile nav, reveal animations, back-to-top, current year
   Config via <script ... data-* attrs> or window.ClickaByteTheme
*/

(() => {
  const confTag = document.currentScript;
  const CFG = Object.assign({
    headerUrl: confTag?.dataset.header || "./assets/parts/header.html",
    footerUrl: confTag?.dataset.footer || "/assets/parts/footer.html",
    logo: confTag?.dataset.logo || "./assets/logo-square.png",
    org: confTag?.dataset.org || "Chaldon Fox Associates Limited",
    tagline: confTag?.dataset.tagline || "/ Software Development",
    defaultTheme: confTag?.dataset.theme || "light",
  }, (window.ClickaByteTheme || {}));

  const root = document.documentElement;
  if (!root.hasAttribute("data-theme")) root.setAttribute("data-theme", CFG.defaultTheme);

  const qs = (s, el=document) => el.querySelector(s);
  const qsa = (s, el=document) => Array.from(el.querySelectorAll(s));
    
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href*="#"]');
  if (!a) return;

  const url = new URL(a.getAttribute('href'), location.href);
  // ignore empty hashes or external pages
  if (!url.hash || url.hash === '#') return;
  if (url.origin !== location.origin) return;

  // only intercept when the link points to the current page
  if (url.pathname === location.pathname) {
    const target = document.querySelector(url.hash);
    if (target) {
      e.preventDefault();
       if (window.lenis) {
         window.lenis.scrollTo(target, { lock: true }); // lock prevents wheel fighting
       } else {
         target.scrollIntoView({ behavior: 'smooth', block: 'start' });
       }

      // close mobile nav if open
      const nav = document.querySelector('.cb-nav');
      const toggle = document.getElementById('cbMenuToggle');
      if (nav?.classList.contains('cb-open')) {
        nav.classList.remove('cb-open');
        toggle?.setAttribute('aria-expanded', 'false');
      }
    }
  }
});

  function setupReveal() {
    const els = qsa(".cb-reveal");
    if (!els.length || !("IntersectionObserver" in window)) return;
    const obs = new IntersectionObserver((entries, o)=>{
      entries.forEach(e=>{
        if (e.isIntersecting) {
          e.target.classList.add("cb-show");
          o.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => obs.observe(el));
  }

  function setupThemeToggle() {
    const saved = localStorage.getItem("theme");
    if (saved) root.setAttribute("data-theme", saved);
    const btn = qs("#cbThemeBtn");
    if (btn) btn.addEventListener("click", ()=>{
      const t = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
      root.setAttribute("data-theme", t); localStorage.setItem("theme", t);
    });
  }

  function setupMobileNav(scope=document) {
    const nav = qs(".cb-nav", scope);
    const toggle = qs("#cbMenuToggle", scope);
    const links = qs("#cbNavLinks", scope);
    if(!nav || !toggle || !links) return;

    const close = () => { nav.classList.remove('cb-open'); toggle.setAttribute('aria-expanded','false'); };
    toggle.addEventListener('click', () => {
      const open = !nav.classList.contains('cb-open');
      nav.classList.toggle('cb-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    qsa('a', links).forEach(a => a.addEventListener('click', close));
    window.addEventListener('resize', () => { if (window.innerWidth > 860) close(); });
  }

  function setupFooterBits(scope=document) {
    const y = qs("#footer-year", scope);
    if (y) y.textContent = String(new Date().getFullYear());
    const btt = qs("#cbBackToTop", scope);
    if (btt) btt.addEventListener("click", () => {
       if (window.lenis) window.lenis.scrollTo(0, { lock: true });
       else window.scrollTo({ top: 0, behavior: 'smooth' });
     });
  }

  function applyBrand(scope=document) {
    const logo = CFG.logo;
    const org = CFG.org;
    const tagline = CFG.tagline;

    const brandLink = qs(".cb-brand", scope);
    if (brandLink) {
      const img = qs(".cb-brand-logo", brandLink);
      if (img && logo) img.src = logo;
      const strong = qs("strong", brandLink);
      if (strong) strong.textContent = org;
      const span = brandLink.querySelector("span.cb-muted");
      if (span) span.textContent = ` ${tagline}`;
    }

    const footerLogo = qs(".cb-footer-brand img", scope);
    if (footerLogo && logo) footerLogo.src = logo;

    const footerStrong = qs(".cb-footer-brand strong", scope);
    if (footerStrong) footerStrong.textContent = org;
  }

  async function inject(targetSelector, url) {
    let mount = qs(targetSelector);
    const html = await fetch(url, { credentials: "same-origin" }).then(r => r.text()).catch(()=>null);
    if (!html) return null;

    const tmp = document.createElement("div");
    tmp.innerHTML = html.trim();

    const el = tmp.firstElementChild;
    if (!mount) {
      if (/header|nav/i.test(el.tagName)) {
        document.body.prepend(el);
      } else {
        document.body.appendChild(el);
      }
    } else {
      mount.replaceWith(el);
    }
    return el;
  }

  document.addEventListener("DOMContentLoaded", async () => {

    const headerEl = await inject("#cb-header", CFG.headerUrl);
    const footerEl = await inject("#cb-footer", CFG.footerUrl);
    
    if (document.getElementById('callbackModal')) return;

    const html = String.raw`
<div id="callbackModal" class="cf-modal" aria-hidden="true">
  <div class="cf-modal__backdrop" data-close-modal></div>

  <div class="cf-modal__panel" role="dialog" aria-modal="true" aria-labelledby="callbackTitle" aria-describedby="callbackDesc">
    <button class="cf-modal__close" type="button" aria-label="Close dialog" data-close-modal>
      <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>

    <header class="cf-modal__header">
      <h2 id="callbackTitle">Request a callback</h2>
      <p id="callbackDesc" class="cf-modal__sub">Leave your details and we’ll be in touch.</p>
    </header>

    <form id="callbackForm" class="cf-modal__form" method="post" action="/request-callback">
      <label class="cf-field">
        <span class="cf-label">Name</span>
        <input class="cf-input" name="name" type="text" autocomplete="name" required placeholder="John Smith" />
      </label>

      <label class="cf-field">
        <span class="cf-label">Phone</span>
        <input class="cf-input" name="phone" type="tel" inputmode="tel" autocomplete="tel"
               required placeholder="+44 7700 987654"
               pattern="^[0-9+()\\-\\.\\s]{7,}$"
               title="Please enter a valid phone number." />
      </label>

      <button class="btn btn-primary cf-submit" type="submit">Submit</button>

      <p class="cf-modal__note">By submitting, you agree to our <a href="./privacy-policy" class="cf-link">privacy notice</a>.</p>
      <div class="cf-modal__status" aria-live="polite"></div>
    </form>
  </div>
</div>
    `;

    const tpl = document.createElement('template');
    tpl.innerHTML = html.trim();
    document.body.appendChild(tpl.content.firstElementChild);

    // Optional: simple close/open helpers using the [data-close-modal] triggers
    const modal = document.getElementById('callbackModal');
    const setHidden = (hidden) => {
      modal.setAttribute('aria-hidden', String(hidden));
      document.body.style.overflow = hidden ? '' : 'hidden'; // lock scroll when open
    };
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-close-modal]')) setHidden(true);
    });

    // Expose simple open/close on window for convenience
    window.openCallbackModal = () => setHidden(false);
    window.closeCallbackModal = () => setHidden(true);

    setupMobileNav(document);
    setupThemeToggle();
    setupReveal();
    if (footerEl) setupFooterBits(document);
    applyBrand(document);
  });
})();



